import {
  ChangeDetectionStrategy,
  Component, Injector, input,
} from '@angular/core';
import { ActionModel } from '@models/admin/action.model';
import { NgStyle } from '@angular/common';
import { TranslationPipe } from '@pipes/translation.pipe';
import { UiBtnComponent } from '@components/ui-components/ui-btn/ui-btn.component';
import { ActionHandlerService } from '@services/admin/action-handler.service';

@Component({
  selector: 'app-action-btn',
  standalone: true,
  imports: [
    TranslationPipe,
    UiBtnComponent,
    NgStyle,
  ],
  templateUrl: './action-btn.component.html',
  styleUrl: './action-btn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionBtnComponent {
  action = input<ActionModel>();
  methodAfterAction = input<() => void>();
  data = input(null);
  fullWidth = input(false);

  private readonly actionHandlerService?: ActionHandlerService;

  constructor(private injector: Injector) {
    try {
      this.actionHandlerService = this.injector.get(ActionHandlerService);
    } catch {
    }
  }

  clickAction() {
    this.actionHandlerService.executeAction(this.action(), this.data(), this.methodAfterAction());
  }
}

